import { useEffect, useState } from 'react';

// Components
import Textbox from '../../../../components/Textbox';

interface WhitelistedDomainProps {
  index: number;
  value: string;
  onChange: (val: string, index: number) => void;
  onRemove: (index: number) => void;
}

function WhitelistedDomain({
  value,
  index,
  onChange,
  onRemove,
}: WhitelistedDomainProps) {
  const [newValue, setNewValue] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const [errorMsg, setErrorMsg] = useState<string | null>(null);

  const onEdit = (val: string) => {
    setNewValue(val);
  };

  useEffect(() => {
    setNewValue(value);
  }, [value]);

  const onEditConfirm = () => {
    if (isEditing) {
      try {
        onChange(newValue, index);
        setIsEditing(false);
        setErrorMsg(null);
      } catch (err) {
        let errMsg = 'Invalid value';
        if (err instanceof Error) {
          errMsg = err.message || errMsg;
        }
        setErrorMsg(errMsg);
      }
      return;
    }
    onRemove(index);
  };

  const onEditCancel = () => {
    if (errorMsg) {
      setErrorMsg(null);
    }
    if (isEditing) {
      setNewValue(value);
    }
    setIsEditing((prev) => !prev);
  };

  return (
    <div className="relative">
      <div className="flex-1">
        <Textbox
          inputClassName="disabled:!text-black focus:border-error"
          onChange={onEdit}
          value={newValue}
          disabled={!isEditing}
          errorMessage={errorMsg}
        />
      </div>
      <div
        className={`absolute top-1/2 -translate-y-1/2 right-4 flex gap-2 ${
          errorMsg ? '-translate-y-5' : ''
        }`}
      >
        <i
          className={isEditing ? 'icon-cancel' : 'icon-edit'}
          title={isEditing ? 'Cancel' : 'Edit'}
          onClick={onEditCancel}
        />
        <i
          className={`inline-block icon-${
            isEditing ? 'check h-6 w-6' : 'delete h-5 w-5'
          }`}
          title={isEditing ? 'Confirm' : 'Delete'}
          onClick={() => {
            onEditConfirm();
          }}
        />
      </div>
    </div>
  );
}

export default WhitelistedDomain;
